<div class="container">
  <mat-card class="not-available-card not-available-text">
    <p>
      Apologies, it appears this offer is no longer available. Please feel free to ask a hotel team member about upgrades upon check-in.
    </p>
  </mat-card>
</div>



